export class ApiObjectCollection {

    constructor(collection, store) {
        this.collection = collection;
    }

    //Every api object has an id. It's often most easy to work with the id.
    getById(id) {
        const retval = this.collection.filter((object) => object.id == id)

        if (retval) {
            //We use .pop() because filter always returns an array.
            return retval.pop();
        }
        else {
            return null;
        }
    }

    //Allows you to get something using array notation... e.g. this.store.accounts[0]
    indexOf(id) {
        return this.collection[id];
    }
}